import Theme from '@adsk/alloy-react-theme';

export const accordionItem = {
  backgroundColor: Theme.colors.white,
};

export const accordionContainer = {
  marginLeft: '28px',
};

export const titleText = {
  ...Theme.typography.bodyMediumBold,
  color: Theme.colors.charcoal900,
};

export const secondaryText = {
  ...Theme.typography.bodySmall,
  color: Theme.colors.charcoal900,
};

export const labelText = {
  ...Theme.typography.caption,
  color: Theme.colors.charcoal700,
};

export const footer = {
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '28px',
};

export const footerSideText = {
  ...Theme.typography.bodySmallBold,
};

export const footerDateText = {
  ...labelText,
  marginRight: '16px',
};
